import { render, staticRenderFns } from "./GroupRules.vue?vue&type=template&id=2b3b0d20&scoped=true&"
import script from "./GroupRules.vue?vue&type=script&lang=js&"
export * from "./GroupRules.vue?vue&type=script&lang=js&"
import style0 from "./GroupRules.vue?vue&type=style&index=0&id=2b3b0d20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b0d20",
  null
  
)

export default component.exports